/**
 * ネイティブプラットフォームブリッジマネージャ (NativePlatformBridge)
 * aidlc-docs/construction/desktop_ambient_platform/docs/native_platform_bridge_component.md 準拠
 */

import type { IPlatformBridgeAdapter } from './bridges/IPlatformBridgeAdapter';
import { ElectronBridgeAdapter } from './bridges/ElectronBridgeAdapter';
import { WebEmulatedBridgeAdapter } from './bridges/WebEmulatedBridgeAdapter';
import { NullPlatformBridgeAdapter } from './bridges/NullPlatformBridgeAdapter';

export type PlatformType = 'electron' | 'tauri' | 'web_emulated' | 'null';

export interface NativePlatformBridgeOptions {
  adapter?: IPlatformBridgeAdapter;
  edition?: 'web_free' | 'pc_app_paid' | 'mobile_app_paid';
}

export class NativePlatformBridge {
  private adapter: IPlatformBridgeAdapter;

  constructor(options: NativePlatformBridgeOptions = {}) {
    if (options.adapter) {
      this.adapter = options.adapter;
    } else if (options.edition === 'web_free' || options.edition === 'mobile_app_paid') {
      // 無料版またはスマホ版はNullアダプタを使用
      this.adapter = new NullPlatformBridgeAdapter();
    } else {
      // プラットフォーム自動検出
      this.adapter = this.createDefaultAdapter();
    }
  }

  /**
   * 現在のアダプタを取得
   */
  public getAdapter(): IPlatformBridgeAdapter {
    return this.adapter;
  }

  /**
   * アダプタを手動設定 (テスト・DI用)
   */
  public setAdapter(adapter: IPlatformBridgeAdapter): void {
    this.adapter = adapter;
  }

  /**
   * 実行環境の自動判別
   */
  public detectPlatform(): PlatformType {
    if (typeof window !== 'undefined' && (window as any).electronAmbientAPI) {
      return 'electron';
    }
    if (typeof window !== 'undefined' && (window as any).__TAURI__) {
      return 'tauri';
    }
    if (this.adapter instanceof NullPlatformBridgeAdapter) {
      return 'null';
    }
    return 'web_emulated';
  }

  private createDefaultAdapter(): IPlatformBridgeAdapter {
    if (typeof window !== 'undefined' && (window as any).electronAmbientAPI) {
      return new ElectronBridgeAdapter();
    }
    // ブラウザまたは開発環境
    return new WebEmulatedBridgeAdapter();
  }
}
